import { MessageCircleQuestion, History } from 'lucide-react'
import type { BottomNavItem } from '@/registry/types'

/**
 * Bottom nav:
 *   [Ask] [History]
 *
 * - Ask      the live surface: drop in what was said, get follow-up questions
 *            (the saved-conversation detail route lives under /c/, so keep Ask
 *            active there too)
 * - History  past conversations, re-openable and resumable
 */
export const curiousBottomNav: BottomNavItem[] = [
  {
    id: 'ask',
    label: 'Ask',
    icon: MessageCircleQuestion,
    href: '/apps/curious',
    matchPrefixes: ['/apps/curious/c/'],
  },
  {
    id: 'history',
    label: 'History',
    icon: History,
    href: '/apps/curious/history',
  },
]
